export const getComparisonCardsItems = (componentData, getComposePageUrl) => {
    return {
        bgColor: componentData?.fields?.backgroundColour,
        gridSpacing: componentData?.fields?.gridSpacing,
        gridColumns: componentData?.fields?.gridColumns,
        title: componentData?.fields?.title,
        subtitle: componentData?.fields?.subtitle,
        items: componentData?.fields?.elements?.map((e, index) => {
            let url = e?.fields?.ctaLinks?.[0]?.fields?.url;
            let isContentPageLinked = false;
            if (e?.fields?.ctaLinks?.[0]?.fields?.contentPage?.fields?.slug) {
                isContentPageLinked = true;
                url = e?.fields?.ctaLinks?.[0]?.fields?.contentPage?.fields?.slug;
            }
            return {
                id: e?.sys?.id,
                bgColor: index === 0 ? "#FDF6EB" : "#DBECF8",
                imageTitle: e?.fields?.image?.fields?.title,
                imageUrl: e?.fields?.image?.fields?.file?.url,
                title: e?.fields?.title,
                description: e?.fields?.description,
                cta: {
                    ...e?.fields?.ctaLinks?.[0]?.fields,
                    url: isContentPageLinked ? getComposePageUrl(url) : url
                }
            };
        })
    };
};
